var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Museums"}},[_c('SimpleSlider',{attrs:{"img":"/images/museums/slide.webp"}}),_c('div',{staticClass:"max-body-container margin"},[_c('TitlesComponent',{attrs:{"title":"¡Soluciones de acceso y gestión de visitantes !"}})],1),_c('AxessOffers'),_c('CardsGaleryData'),_c('YouChooseYourTicket'),_c('YouHaveTheControl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }